/* eslint-disable react/jsx-props-no-spreading */
import {
  CoachingFormData,
  ContactInput,
  ContactReviewItemLabelObject,
} from '../../../api/CoachingForm/schema';
import { ContactFromGetter } from './Data';

// Re-construct contact with proper structure
export const filterContact = (
  aggregatedContact: ContactFromGetter[],
  contactReview: ContactInput,
  values: CoachingFormData
): ContactInput => {
  const matchedContact = aggregatedContact.find(
    contact => contact.contactID === contactReview.cscContactID
  );
  let contactData: ContactInput = {
    ...contactReview,
    marketplaceDomainName: matchedContact?.marketplaceDomainName,
    marketplaceID: matchedContact?.marketplaceID,
    contactTime:
      (matchedContact?.label === ContactReviewItemLabelObject.RECOMMENDED ||
        matchedContact?.label === ContactReviewItemLabelObject.REVIEWED) &&
      matchedContact.calWeek !== undefined &&
      matchedContact.calYear !== undefined
        ? {
            calWeek: parseInt(matchedContact.calWeek, 10),
            calYear: parseInt(matchedContact.calYear, 10),
          }
        : undefined,
  };

  const matchedCoachingContact = values.contactReview.find(
    contact => contact.cscContactID === contactReview.cscContactID
  );

  if (matchedCoachingContact !== undefined) {
    const { contactTime, marketplaceID, marketplaceDomainName } =
      matchedCoachingContact;

    contactData = {
      ...contactData,
      contactTime:
        contactTime !== undefined ? contactTime : contactData.contactTime,
      marketplaceID:
        marketplaceID !== undefined ? marketplaceID : contactData.marketplaceID,
      marketplaceDomainName:
        marketplaceDomainName !== undefined
          ? marketplaceDomainName
          : contactData.marketplaceDomainName,
    };
  }
  return contactData;
};
